import React from 'react'
import Formsignup from './Formsignup';
import '../../index.css';
import NavbarAuth from '../../components/NavBar/NavbarAuth';

function Signup() {
  return (
    <div className="grid grid-cols-5 bg-gray-100 dark:bg-dark-2">
      <NavbarAuth textButton={"Se connecter"} link={"/auth/login"} />

      {/* Partie image */}
      <div
        className="group col-span-2 w-full bg-cover bg-center bg-no-repeat relative overflow-auto min-h-screen"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1498050108023-c5249f4df085?auto=format&fit=crop&w=1600&q=80')"
        }}
      />

      {/* Form Signup */}
      <div className="col-span-3 bg-gray-100 flex items-center justify-center overflow-y-auto min-h-screen">
        <div className="max-w-[535px] px-4">
          <div className="bg-white rounded-lg px-6 py-8 dark:bg-dark-1">
            <Formsignup />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Signup